$jq.namespace('MatchCore.Header');
$jq.namespace('MatchCore.UI.Site.Header');

MatchCore.UI.Site.Header.ReactivateSubscription = function() {
	var _container;
	var _resub = new MatchCore.Header.Subscription();

	var showConfirmation = function() {
		$jq(".view1").hide();
		$jq(".view2").show();
        setTimeout(function () { $jq(_container).fadeOut(); }, 3000);
	};

	var wireUpControls = function() {
        $jq(_container).bind('mouseenter',
            function() {
                $jq(".prompt", _container).show()
            }).bind('mouseleave',
            function() {
		if ($jq(".tooltip", _container).hasClass("prompt")) {
		    $jq(".prompt", _container).hide()
                    } else {
					}
            }
        );

        $jq(".resubBtn", _container).click(function() {
			$jq(".tooltip", _container).removeClass("prompt");
			
			var opts = {};
			opts.success = showConfirmation;
			_resub.reactivateSubscription(opts);
		});
	};

	var self = {
		init: function(opts) {
			if (opts && opts.container)
				_container = opts.container;

			wireUpControls();
		}
	};
	return self;

};

MatchCore.Header.Subscription = function() {
    var _service = new MatchCore.ServiceProxy('/rest/MainService.ashx');
    var self = {
        reactivateSubscription: function(opts) {
            _service.invoke({
                method: 'ReactivateSubscription',
                data: {
                    'sid': MatchCore.Session.SID(),
                    'theme': MatchCore.Session.ServerId()
                },
                failure: function(xmlhttp, status, exception) {
                    if (opts.failure)
                        opts.failure(xmlhttp, status, exception);
                },
                success: function(response) {
                    if (opts.success)
                        opts.success(response);
                }
            });
        }
    };
    return self;
};

MatchCore.Header.ShowProfile = function() {
    var _service = new MatchCore.ServiceProxy('/rest/MainService.ashx');
    var self = {
        init: function(opts) {
            if (opts.container)
                $jq(opts.container).click(
                function() {
                    _service.invoke(
                    {
                        method: 'UnhideProfile',
                        data: {
                            'sid': MatchCore.Session.SID(),
                            'theme': MatchCore.Session.ServerId()
                        },
                        failure: function(xmlhttp, status, exception) {
                        },
                        success: function(response) {
                            if (response.Success) {
                                $jq("#SharkFinModal").behavior('MatchCore.UI.Site.ModalDialog', function(modal) {
                                    modal.show();
                                });
                            }
                        }
                    });
                }
            );
        }
    };
    return self;
}

MatchCore.Header.Navigation = function () {
    var _container = null;
    var _minWidth = ($jq('body').hasClass('ie6')) ? "width" : "minWidth";

    var wireUpControls = function () {
        $jq(_container).children('li').bind('mouseenter touchstart',
            function(e) {
                if (!$jq(this).children('a').hasClass('navItemHighlight') && !$jq(this).hasClass('noMenu')) {
                    //console.log(e);
                    if(e.type !== "touchstart")
                        e.preventDefault();
                }
                $jq(".menuItem").hide();
                $jq(".navItem").removeClass("navItemHighlight");
                $jq(".menuItem", this).show().css(_minWidth, $jq(this).outerWidth());
			    $jq(".navItem", this).addClass("navItemHighlight");
			}).bind('mouseleave',
			function () {
			    $jq(".menuItem", this).hide();
			    $jq(".navItem", this).removeClass("navItemHighlight");
			}
		);
    };

    var self = {
        init: function (opts) {
            if (opts.container) {
                _container = opts.container;
                wireUpControls();
            } 
        }
    };
    return self;
};
